import { OrderAttentionBanner } from 'rentalui-finance';
import { client } from '../api';
import { useAuth } from '../auth';

export default function OrderAttentionAlert({ navOnly = false }) {
  const { user } = useAuth();
  const has = (role) => user?.role === role || user?.roles?.includes(role);
  return <OrderAttentionBanner key={`${user?.id || user?.email}:${user?.role}:${(user?.roles || []).join(',')}`} client={client} enabled={navOnly ? !!has('admin') : !!(has('owner') && !has('admin'))}
    isAdmin={!!has('admin')} vertical="real_estate" viewerKey={user?.id || user?._id || user?.email} />;
}
